import React from "react";
import { View, FlatList, ScrollView } from "react-native";
import { Text } from "../../../../components/Text";
import { linesStyles as styles } from "./styles";
import { LineItemWithProdType } from "@/app/types/line-items";
import { getLocalisedNumber, useTranslateText } from "@/app/utils/translations";
import { formatMoney } from "@/app/utils/currency";

type LinesProps = {
  items: LineItemWithProdType[];
};

const Lines = ({ items }: LinesProps): JSX.Element => {
  const { locale } = useTranslateText();
  return (
    <ScrollView contentContainerStyle={styles.container}>
      <FlatList
        contentContainerStyle={styles.orderLinesContainer}
        data={items}
        renderItem={({ item }) => {
          const rowItemName = `${getLocalisedNumber(item.quantity, locale)} x ${
            item.title
          }`;
          return (
            <View style={styles.orderItemsContainer}>
              <View style={styles.orderItemsTitleContainer}>
                <Text style={styles.itemHeader}>{rowItemName}</Text>
                {item.choices?.map((choice, i) => (
                  <Text style={styles.itemChoice} key={i}>
                    {choice.receiptName?.[locale]}
                  </Text>
                ))}
              </View>
              <View style={styles.orderItemsPriceContainer}>
                <Text style={styles.itemPrice}>
                  {formatMoney(item.total, true, locale).amount}
                </Text>
              </View>
            </View>
          );
        }}
      />
    </ScrollView>
  );
};

export default Lines;
